import React, { useEffect, useState } from "react";
import "./style.scss";
import { useGetAllBatches } from "../../hooks/useOrderBatches";
import { Pagination, Spin, Table } from "antd";
import {
  useGetPurchaseHistory,
  useGetWalletTransactions,
} from "../../hooks/useUserWallet";
import { Link } from "react-router-dom";

const Billing = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [walletTransactions, setWalletTransactions] = useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [pageNum, setPageNum] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [walletPageSize, setWalletPageSize] = useState(15);
  const [walletPageNum, setWalletPageNum] = useState(1);
  const [walletTotalCount, setWalletTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [tabsData, setTabsData] = useState([
    {
      id: 1,
      title: "Recharge History",
    },
    {
      id: 2,
      title: "Wallet History",
    },
  ]);

  const onSuccessGetPurchaseHistory = (res) => {
    if (res.status === 200) {
      setLoading(false);
      setPurchaseHistory(res?.data?.data);
      setTotalCount(res?.data?.totalCount);
    }
  };
  const onErrorGetPurchaseHistory = (err) => {
    console.log(err);
  };
  const { data: getPurchaseHistory, refetch: fetchPurchaseHistory } =
    useGetPurchaseHistory(
      "getPurchaseHistory",
      pageNum,
      pageSize,
      onSuccessGetPurchaseHistory,
      onErrorGetPurchaseHistory,
      {
        enabled: false,
      }
    );

  const onSuccessGetWalletTransactions = (res) => {
    if (res.status === 200) {
      setLoading(false);
      setWalletTransactions(res?.data?.data);
      setWalletTotalCount(res?.data?.totalCount);
    }
  };
  const onErrorGetWalletTransactions = (err) => {
    console.log(err);
  };
  const { data: getWalletTransactions, refetch: fetchWalletTransactions } =
    useGetWalletTransactions(
      "getWalletTransactions",
      walletPageNum,
      walletPageSize,
      onSuccessGetWalletTransactions,
      onErrorGetWalletTransactions,
      {
        enabled: false,
      }
    );

  const handleActiveTab = (id) => {
    setActiveTab(id);
    if (id === 1) {
      fetchPurchaseHistory();
    } else {
      fetchWalletTransactions();
    }
  };

  const onPageChange = (page, size) => {
    if (page !== pageNum) {
      setPageNum(page);
    } else {
      setPageSize(size);
      setPageNum(1);
    }
  };

  const onWalletPageChange = (walletPage, walletSize) => {
    if (walletPage !== walletPageNum) {
      setWalletPageNum(walletPage);
    } else {
      setWalletPageSize(walletSize);
      setWalletPageNum(1);
    }
  };

  const formattedDate = (uploadedDate) => {
    const date = new Date(uploadedDate);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const newDate = date.toLocaleDateString("en-US", options);
    return newDate;
  };

  const columns = [
    {
      title: "Date",
      key: "createdAt",
      align: "center",
      dataIndex: "createdAt",
      render: (_, record, index) => {
        return <div className="">{formattedDate(record?.createdAt)}</div>;
      },
    },
    {
      title: "Transaction ID",
      key: "purchaseCode",
      align: "center",
      dataIndex: "purchaseCode",
      render: (_, record, index) => {
        return <div>{record?.purchaseCode}</div>;
      },
    },
    {
      title: "Amount",
      key: "amount",
      align: "center",
      dataIndex: "amount",
      render: (_, record) => {
        return (
          <div>{`${record?.currency?.toLowerCase() === "usd" ? "$" : ""}${record?.amount}`}</div>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      align: "center",
      dataIndex: "status",
      render: (_, record) => {
        return (
          <div
            className={`status ${
              record.status === "pending"
                ? "pending"
                : record?.status === "succeeded"
                ? "complete"
                : record?.status === "failed" && "failed"
            }`}
          >{`Payment ${record?.status}`}</div>
        );
      },
    },
    {
      title: "Invoice",
      key: "",
      align: "center",
      dataIndex: "",
      render: (_, record) => {
        return (
          <div>
            {record?.status === "failed" || record?.status === "pending" ? (
              ""
            ) : record?.invoiceInfo ? <Link to={record?.invoiceInfo?.invoice_pdf} className="download">
                Download
              </Link> : ""
            }
          </div>
        );
      },
    },
  ];

  const walletColumns = [
    {
      title: "Date",
      key: "createdAt",
      align: "center",
      dataIndex: "createdAt",
      render: (_, record, index) => {
        return <div className="">{formattedDate(record?.createdAt)}</div>;
      },
    },
    {
      title: "Batch Name",
      key: "",
      align: "center",
      dataIndex: "",
      render: (_, record, index) => {
        return <div className="batch_id">{record?.identity?.batch?.name}</div>;
      },
    },
    {
      title: "Transaction Amount",
      key: "unitAmount",
      align: "center",
      dataIndex: "unitAmount",
      render: (_, record, index) => {
        console.log(record);
        return (
          <div className={`unit_amount ${record?.nature!== "credit" ? "debit" : ""}`}>
            {
              record?.nature !== "credit"
               ?
               `-${record?.amount?.currency.toLowerCase() === "usd" ? "$": ""}${record?.amount?.unitAmount}`
               :
               `+${record?.amount?.currency.toLowerCase() === "usd" ? "$": ""}${record?.amount?.unitAmount}`
            }
            </div>
        );
      },
    },
    {
      title: "Available Balance",
      key: "availableBalance",
      align: "center",
      dataIndex: "availableBalance",
      render: (_, record, index) => {
        return (
          <div className="">{`${
            record?.availableBalance?.currency === "USD" ? "$" : "-"
          }${
            record?.availableBalance?.unitAmount
              ? record?.availableBalance?.unitAmount
              : "-"
          }`}</div>
        );
      },
    },
    // {
    //   title: "Invoice",
    //   key: "",
    //   align: "center",
    //   dataIndex: "",
    //   render: (_, record, index) => {
    //     return <div className=""></div>;
    //   },
    // },
  ];

  return (
    <div className="billing_section">
      <div class="billing_message">Billing</div>
      <div className="billing_wrapper">
        <div className="billing_tabs">
          {tabsData?.map((tab) => {
            return (
              <button
                className={`tab ${activeTab === tab?.id ? "active" : ""}`}
                onClick={() => {
                  handleActiveTab(tab?.id);
                }}
              >
                {tab?.title}
              </button>
            );
          })}
        </div>
        <div className="tab_content">
          <div className="table_content_wrapper">
            {loading ? (
              <Spin />
            ) : (
              <Table
                columns={activeTab === 1 ? columns : walletColumns}
                dataSource={
                  activeTab === 1 ? purchaseHistory : walletTransactions
                }
                scroll={{
                  // x: 2100,
                  y: `calc(80% )`,
                }}
                className="main_table"
                pagination={false}
              />
            )}
          </div>
        </div>
      </div>
      <div className="pagination_wrapper">
        <Pagination
          total={activeTab === 1 ? totalCount : walletTotalCount}
          // showTotal={false}
          defaultPageSize={10}
          current={activeTab === 1 ? pageNum : walletPageNum}
          pageSize={activeTab === 1 ? pageSize : walletPageSize}
          onChange={activeTab === 1 ? onPageChange : onWalletPageChange}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default Billing;
